var XPortal = XPortal || {};
XPortal.Dropdown = (function () {
    var self =
    {
        index: 0,
        isWorking: false,
        ControlSelector: ".xpand-dropdown",
        ControlSelectorNotInFSet: ".xpand-dropdown:not(.dynamic-filter-set .xpand-dropdown)",
        Init: function (container, exceptFSets) {
            var self = this;
            container = container ? container : $(XPortal.Main.DetialFormSelector);
            container.find(exceptFSets ? self.ControlSelectorNotInFSet : self.ControlSelector).each(function () {
                self.initFor(XPortal.Store.getModelName(container[0].id), $(this));
            });
        },
        initFor: function (modelName, el, isInlineEditor = false, modelFields) {
            const sttgs = getSettingsFor(el, self.index++, modelName, modelFields);
            const mbox = self.initDropDownFor(modelName, el, sttgs, isInlineEditor);
            ////////////////////////////////////////////////////////////////////////////////
            XPortal.Store.Subscribe({ Model: modelName, Field: sttgs.fieldname, Target: mbox },
                (value, action) => {
                    var cvalue = self.GetDropDownValue(mbox, sttgs);
                    if (sttgs.ismultiselect) cvalue = cvalue.split(sttgs.valueSeparator).sort().join(sttgs.valueSeparator);
                    if (XPortal.DefaultEditor.IsModified(el, cvalue)) return;
                    self.SetDropDownValue(el, mbox, value, sttgs);
                    el.trigger("change");
                    XPortal.DefaultEditor.ClearModification(el);
                },
                (value, lActionField) => {
                    if (lActionField && lActionField.data && lActionField.data.join && !lActionField.ismultiselect) return value;
                    const cval = self.GetDropDownValue(mbox, sttgs);
                    if (!cval && !value) return value;
                    return cval;
                }
            );
        },
        updateFor: function (updatedFieldName, frm) {
            window.clearTimeout(self.tmoutRebindDynodropdowns);
            self.tmoutRebindDynodropdowns = window.setTimeout(function () {
                var elements = frm ? frm.find("input.xpand-dropdown[data-filtertype*='CurrentEntity'], select.xpand-dropdown[data-filtertype*='CurrentEntity']") : $("input.xpand-dropdown[data-filtertype*='CurrentEntity'], select.xpand-dropdown[data-filtertype*='CurrentEntity']");
                elements.each(function (_dd, dropDown) {
                    var fName = dropDown.dataset.filtertype;
                    if (fName && fName.split("|").length > 1 && fName.indexOf("CurrentEntity") > -1) {
                        var linkedFields = fName.split("|")[1].split(";");
                        if (linkedFields.indexOf(updatedFieldName) > -1) { //refresh dropdown
                            var frmContainer = $(dropDown).closest(XPortal.Main.DetialFormSelector);
                            var mid = XPortal.Store.getModelName(frmContainer.attr("id"));
                            var modelFields = getModelFields($(dropDown), mid);
                            XPortal.Dropdown.reInitFor(mid, dropDown, modelFields);
                        }
                    }
                });
            }, 300);
        },
        showErrorPopupMsg: function (sttgs, bdata, e, dataName) {
            sttgs.update = false;
            console.log(`can't load ${dataName} data`, { a: bdata.entityAlias, f: bdata.fieldAlias, bdata, e });
            var $popup = $("#errorBox");
            $popup.find('.modal-body p').text(sttgs.errorMsg);
            $popup.modal('show');
        },
        closeMultiDropdown: function (btn) {
            var $wrapper = $(btn).closest('.k-multiselect');
            if (!$wrapper.length) return;
            var $select = $wrapper.find('select');
            if (!$select.length) return;
            var multiselect = $select.data("kendoMultiSelect");
            if (multiselect == null) return;
            if ($wrapper.hasClass('k-state-border-up') || $wrapper.hasClass('k-state-border-down')) {
                multiselect.focus();
                multiselect.toggle();
            }
        },
        getDefaultTemplate: function (columnName) {
            return "<p>#:data." + columnName + "#</p>";
        },
        initDropDownFor: function (modelName, el, sttgs, isInlineEditor) {
            var mbox = null;
            const bdata = sttgs.bdata;
            el.change(function () {//is comming from dropdown
                let elval = el.val();
                elval = elval && _.isArray(elval) ? elval.join(sttgs.valueSeparator) : elval;
                if (sttgs.ismultiselect) elval = elval.split(sttgs.valueSeparator).sort();
                XPortal.DefaultEditor.SetModification(el, elval);
                sttgs.value = elval;
                mbox.value(elval);
                if (!isInlineEditor) {
                    sttgs.bdata.isInitializing = true;
                    setTimeout(function () { el.trigger("dispatchFieldEvent") }, 1);
                }
            });
            if (isInlineEditor && el) $(el).attr("data-skip", "");
            el.bind("dispatchFieldEvent", function (e) {
                const cvalue = self.GetDropDownValue(mbox, sttgs);
                if (sttgs.editable || initValue == cvalue) {
                    var displayitems = _.map(mbox.listView._dataItems, function (dx, di) { return (dx.display || dx.title) || dx.value; }).join(", ");
                    XPortal.Store.DispatchDisplayValue(el, displayitems || cvalue, modelName, sttgs);
                    XPortal.Store.FieldEvent(el, cvalue, modelName, sttgs);
                }
            });
            bdata.isInitializing = true;
            var requestDataMethod = function (options) {
                const sttgs = _dataSource.options.xsettings;

                let requestid = bdata.latestexid = bdata.latestexid > 0 ? bdata.latestexid + 1 : 1;
                //console.log("-------new request: " + requestid);
                let rdata = initSearchRequestData(el, options, sttgs);
                showHideLoader(getKendoControl(el, sttgs), sttgs, true);

                loadInitialData(requestid, el, bdata, rdata, sttgs, options).then(function (dataPreloaded) {
                    loadMainData(requestid, el, bdata, rdata, sttgs, options).then(function (result) {
                        bdata.action = "";
                        bdata.isInitializing = false;
                        rdata = addMainQuery(rdata, options, result.mquery);
                        if (!result.loaded)
                            loadFinalData(requestid, el, bdata, rdata, sttgs, options).catch(function (e) { if (e !== false) { self.showErrorPopupMsg(sttgs, bdata, e, "final"); } });
                    }).catch(function (e) { if (e !== false) { self.showErrorPopupMsg(sttgs, bdata, e, "main"); } });
                }).catch(function (e) { if (e !== false) { self.showErrorPopupMsg(sttgs, bdata, e, "initial"); } });
            };
            var _dataSource = new kendo.data.DataSource({ serverFiltering: sttgs.isServerFiltering, serverPaging: sttgs.isServerFiltering, serverSorting: sttgs.isServerFiltering, serverAggregates: sttgs.isServerFiltering, serverGrouping: sttgs.isServerFiltering, transport: { read: requestDataMethod }, schema: { total: "total" }, xsettings: sttgs });
            var beforeOpen = null;
            var kendoOptions = $.extend(sttgs.kendoOptions, {
                dataSource: _dataSource,
                autoClose: false,
                dataBound: function (e) {
                    // console.log("dataBound");
                    if (sttgs.editable === "1") e.sender.readonly(false);
                },
                change: function (e) {
                    e.preventDefault();
                    //  console.log("change");
                    var cvalue = self.GetDropDownValue(this, sttgs);
                    $(this.element).parent().parent().find(".xpand-multiselect-val").val(cvalue);
                },
                open: function (e) {
                    //  console.log("open");
                    beforeOpen = e.sender.value();
                    reloadFooterPager(el, sttgs, _dataSource, "");
                },
                select: function (e) {
                    //console.log("select");
                },
                filtering: function (e) {
                    //   console.log("filtering");
                },
                close: function (e) {
                    // console.log("close");
                    bdata.mainQuery = "";
                    if (!sttgs.ismultiselect) {
                        if (beforeOpen != e.sender.value()) e.sender.trigger("change");
                    }
                }
            });

            mbox = sttgs.ismultiselect ? el.kendoMultiSelect(kendoOptions).data("kendoMultiSelect") : el.kendoComboBox(kendoOptions).data("kendoComboBox");
            if (mbox.input) {
                $.each(el.prop("attributes"), function (iax, ax) {//validation attributes needs to be in input element
                    if (ax.name.indexOf("data-val") == 0)
                        $(mbox.input).attr(ax.name, ax.value);
                });
                $(mbox._clear).on("click", function () {
                    mbox.dataSource.page(0);
                });
            };
            const initValue = self.GetDropDownValue(mbox, sttgs);
            return mbox;
        },
        reInitFor: function (modelName, domEl, modelFields, isInlineEditor = false) {
            let el = $(domEl);
            if (el.length < 1) return;
            let sttgs = getSettingsFor(el);
            mbox = getKendoControl(el, sttgs);
            if (mbox == null)
                self.initFor(modelName, domEl, isInlineEditor, modelFields);
            else {
                sttgs = mbox.dataSource.options.xsettings;
                sttgs.bdata.modelFields = modelFields;
                sttgs.bdata.inittialized = false;
                sttgs.bdata.pageIndex = 0;
                sttgs.bdata.startmval = sttgs.ismultiselect ? mbox.value() : [mbox.value()];
                mbox._clearFilter();
            }
        },
        GetDropDownValue: function (kendoElement, sttgs) {
            // var cvalue = beforeOpen = kendoElement.value();
            var cvalue = beforeOpen = kendoElement.value().length ? kendoElement.value() : sttgs.value ? sttgs.value : "";
            if (!sttgs.update) {
                cvalue = sttgs.value;
                kendoElement.value(cvalue);
            }
            if (!sttgs.bdata.isInitializing) {
                if (cvalue && kendoElement.select && kendoElement.select() === -1)
                    kendoElement.value(cvalue = "");//no sel-item
            }
            cvalue = cvalue && cvalue.length > 0 && cvalue.join ? cvalue.join(sttgs.valueSeparator) : cvalue;
            if (Array.isArray(cvalue) && cvalue.length === 0 && sttgs.update) cvalue = "";

            return cvalue;
        },
        GetSelectedValues: function (iel, sttgs) {
            var eld = self.GetDropDownValue(getKendoControl(iel, sttgs), sttgs);
            let dataItems = sttgs.bdata.dataItems || [];
            dataItems = combineDataSource(dataItems, getKendoControl(iel, sttgs).dataSource.data());
            var res = eld.split("_#_").map(function (x, y) { return dataItems.find(function (y) { return y.value == x; }); });
            res = res.filter(function (x) { return x != null; });
            return res;
        },
        SetDropDownValue: function (el, mbox, value, sttgs) {
            ensureKendoEditor(el, mbox, sttgs, function (imbox) {
                mbox = imbox;
                if (!sttgs.ismultiselect) {
                    mbox.value(value);
                    if (mbox.selectedIndex > -1) return;
                    //reload data in case when value has been changed and doesn't exist in the list 
                    return XPortal.Dropdown.reInitFor(sttgs.bdata.modelName, el, getModelFields(el, sttgs.bdata.modelName));
                }
                var multiselectValue = Array.isArray(value) || !value ? value : value.split(sttgs.valueSeparator);
                if (mbox.element[0].options.length) {
                    mbox.value(multiselectValue);
                    if (mbox.select)
                        return true;
                }
            });
        },
        IsFooterVisible: function (instance) {
            let s = instance.dataSource.options.xsettings;
            return s.bdata.footerVisible;
        },
        IsLoading: function (instance) {
            let s = instance.dataSource.options.xsettings;
            return s.loading || s.bdata.loading;
        },
        GetPagingInfo: function (instance) {
            let s = instance.dataSource.options.xsettings;
            return s.bdata.pageInfo || s.pageInfo;
        }
    };
    function getKendoControl(el, sttgs) {
        return sttgs.ismultiselect ? el.data("kendoMultiSelect") : el.data("kendoComboBox");
    };
    function ensureKendoEditor(el, mbox, sttgs, onOk) {
        let mitms = 0;
        if (!mbox) mbox = getKendoControl(el, sttgs);
        if (mbox) return onOk(mbox);
        XPortal.Utils.waitFor(function () {
            mitms = mitms + 1;
            if (!mbox) mbox = getKendoControl(el, sttgs);
            if (!mbox) return mitms > 5 ? true : false;
            onOk(mbox);
        }, XPortal.Utils.waitFor);
    };
    function searchBy(sttgs, options, rdata, filterfield, onresult, msg, el) {
        if (sttgs.parentInfo) rdata.parentInfo = sttgs.parentInfo;
        var filter = {};
        var res = $.Deferred();
        if (options.data.filter.filters.length > 0 && filterfield) {
            filter = options.data.filter.filters[0];
            options.data.filter.filters = [filter];
            filter.field = filterfield;
        };
        if (options.data.filter.filters.length > 0 && !(options.data.filter.filters[0].value)) {
            options.data.filter.filters = [];
            options.data.page = options.data.pageIndex = 0;
        }
        delete rdata.dataItems;
        let req = { data: rdata, headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() }, options: sttgs, rejected: false };
        el.trigger("lookup.beforeRequest", req);
        if (req.rejected && !req.data.mainQuery && !el.data("_latestSearchMQuery")) {
            onresult(sttgs.bdata.dataItems, filter);
            res.resolve({ data: sttgs.bdata.dataItems, filter });
        } else {
            el.data("_latestSearchMQuery", req.data.mainQuery);
            if (sttgs.srcurl) {
                const ajaxReq = {
                    method: "POST", dataType: sttgs.srctype, cache: false, contentType: 'application/json', url: XPortal.Utils.EnsureInProfile(sttgs.srcurl), data: kendo.stringify({ model: rdata }), headers: req.headers,
                    success: function (xdata) {
                        options.data.filter.filters = [];
                        XPortal.Events.Profile(sttgs.cntrIndex + "-[" + msg + "]-" + rdata.metaField + "                         [info] search for dropdown: [" + rdata.modelName + "/" + rdata.entityAlias + "] in:" + rdata.fieldAlias + "-" + rdata.pageInfo, -1, null, null, $.extend(true, {}, { response: xdata, request: rdata }));
                        if (xdata.ProcessedResult) return onresult(xdata.ProcessedResult.Items, filter);
                        xdata.Result = xdata.Result || {};
                        xdata.Result.Items = xdata.Result.Items || [];
                        try {
                            xdata = XPortal.Grid.ConvertToKendoData(xdata, options, {});
                        } catch (ex) {
                            XPortal.Events.Profile("ERROR:" + ex.message, 1, ex);
                        }
                        validKeys = ["value", "title", "display"];
                        for (var i = 0; i < xdata.length; i++) {
                            Object.keys(xdata[i]).forEach((key) => validKeys.includes(key) || delete xdata[i][key]);
                        }
                        el.trigger("lookup.afterRequest", [el, rdata, xdata]);
                        onresult(xdata, filter);
                        res.resolve({ data: xdata, filter });
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        options.error(jqXHR, textStatus, errorThrown);
                        res.resolve(null);
                    }
                };
                $.ajax(ajaxReq);
            } else {
                console.log(`There is no URL (srcurl property of element) to get data! Maybe element is hidden or not initialised correctly.`, sttgs);
                res.resolve(null);
            }
        }
        return res;
    };
    function loadInitialData(requestid, el, bdata, request, sttgs, options) {
        return new Promise(function (onOk, onErr) {
            sttgs.update = true;
            if (!request.preLoadInitialData) return onOk(false);
            var irdata = options.data.filter.filters.length < 1 ? request : jQuery.extend({}, request, options.data);
            var iPageSize = irdata.pageSize;
            irdata.pageSize = Math.max(irdata.startLength, irdata.pageSize) * 2;
            if (options.data.filter.filters.length > 0)
                searchBy(sttgs, options, irdata, null, function (d, filter) {
                    irdata.pageSize = iPageSize;
                    if (requestid != bdata.latestexid) return onErr(false);
                    bdata.inittialized = true;
                    bdata.dataItems = d;
                    onDataLoaded(el, sttgs, sttgs.editable ? [] : sttgs.bdata.startmval, d, options.success);
                    onOk(true);
                }, "initial", el);
            else XPortal.Utils.waitFor(function () {
                if (!getKendoControl(el, sttgs)) return false;
                irdata.pageSize = iPageSize;
                onOk(false);
                return true;
            }, XPortal.Utils.waitFor, 10);
        });
    }
    function loadMainData(requestid, el, bdata, request, sttgs, options) {
        var mbox = getKendoControl(el, sttgs);
        return new Promise(function (onOk, onErr) {
            //    el.closest('.k-combobox').find('.k-dropdown-wrap .k-input').attr('autocomplete', 'none');//prevent show chrome address popup
            if (requestid != bdata.latestexid) return onErr(false);
            bdata.startmval = [];//clear startup values- to load other data from set
            request = ensureMainQuery(el, sttgs, options, request);
            searchBy(sttgs, options, request, sttgs.valueColumn, function (d, filter) {
                sttgs.update = true;
                if (requestid != bdata.latestexid) return onErr(false);
                sttgs.datafilter = options.data.filter;
                sttgs.bdata.total = d.total || 0;
                showHideLoader(mbox, sttgs, false);
                onDataLoaded(el, sttgs, [], d, options.success, 1);
                cleanUpValueIfNoData(el, d);
                onOk({ loaded: true, mquery: request.mainQuery });
            }, "second", el);
        });
    };
    function ensureMainQuery(el, sttgs, options, request) {
        var mquery = (options.data.filter.filters[0] || {}).value;
        if (!mquery || mquery == "" || options.data.filter.filters.length != 1) {
            sttgs.bdata.mainQuery = "";
            request.mainQuery = "";
            return request;
        }
        request.mainQuery = mquery;
        if (!request.action) {
            sttgs.bdata.mainQuery = request.mainQuery;
            request.pageIndex = 0;
        }
        options.data.filter.filters = [];
        return request;
    };
    function loadFinalData(requestid, el, bdata, request, sttgs, options) {
        var mbox = getKendoControl(el, sttgs);
        return new Promise(function (onOk, onErr) {
            if (requestid != bdata.latestexid) return onErr(false);
            request.mainQuery = "";
            searchBy(sttgs, options, request, null, function (d, filter) {
                sttgs.update = true;
                if (requestid != bdata.latestexid) return onErr(false);
                sttgs.bdata.total = d.total || 0;
                if (requestid != request.latestexid) return onErr(false);
                //var r = combineDataSource(bdata.dataItems, d, true);
                showHideLoader(mbox, sttgs, false);
                if (sttgs.bdata.total < 1) return onDataLoaded(el, sttgs, [], d, options.success, 2);
                cleanUpValueIfNoData(el, d);
                return onDataLoaded(el, sttgs, [], d, options.success);
            }, "third", el);
        });
    }

    function initSearchRequestData(el, searchOptions, controlSettings) {
        var initialData = controlSettings.bdata;
        initialData.dataItems = controlSettings.ismultiselect ? initialData.dataItems || [] : [];
        var rdata = jQuery.extend({}, initialData, searchOptions.data, { pageIndex: initialData.pageIndex ? initialData.pageIndex : 0, pageSize: initialData.pageSize });
        rdata.fields = getFormFields(el, controlSettings);
        if (!searchOptions.data.filter) searchOptions.data.filter = { logic: "and" };
        if (!searchOptions.data.filter.filters) searchOptions.data.filter.filters = [];

        if ((searchOptions.data.filter.filters[0] || {}).operator == controlSettings.filter) controlSettings.action = "";
        if (!initialData.action) initialData.pageIndex = 0;
        else {
            if (searchOptions.data.filter.filters.length < 1 && ((controlSettings.datafilter || {}).length > 0)) {
                searchOptions.data.filter.filters = controlSettings.datafilter;
            }
        };
        rdata.preLoadInitialData = !initialData.inittialized && searchOptions.data.filter.filters.length < 1 && rdata.pageIndex < 1;
        if (rdata.preLoadInitialData)
            initialData.startmval.forEach(function (x) {
                if (x)
                    searchOptions.data.filter.filters.push({ field: controlSettings.valueColumn, operator: "eq", value: x, logic: "or" });
            });
        return rdata;
    };
    function cleanUpValueIfNoData(el, data) {
        var comboBox = el.data("kendoComboBox");
        if (comboBox && (!data || !data.length)) {
            comboBox.text("");
        }
    }

    function combineDataSource(dst, extra) {
        if (dst == null) dst = [];
        extra.forEach(function (x) {
            if (x && x.value) {
                var ex = dst.find(function (y) { return y.value == x.value; });
                if (ex == null) {
                    dst.push(x);
                }
            }
        });
        return dst;
    };
    function getSettingsFor(el, curCtrlindex, modelName, modelFields) {
        var sttgs = XPortal.Main.GetSettingsFor(el);
        sttgs.cntrIndex = curCtrlindex;
        sttgs.srcurl = sttgs.src, sttgs.alias = sttgs.meta.datasource;
        sttgs.entityalias = sttgs.meta.entityname;
        sttgs.alias = sttgs.alias || sttgs.entityalias;
        sttgs.valueColumn = sttgs["value-column"] || "";
        sttgs.errorMsg = sttgs["error-msg"] || "";
        sttgs.titleColumn = sttgs["display-column"] == null || sttgs["display-column"] === "" ? "[[" + sttgs.valueColumn.toLowerCase() + "]]" : sttgs["display-column"];
        sttgs.lookupTemplate = sttgs["lookup-template"] == null || sttgs["lookup-template"] === "" ? "[[" + sttgs.valueColumn.toLowerCase() + "]]" : sttgs["lookup-template"];
        sttgs.editor = "dropdown";
        sttgs.ismultiselect = el.hasClass("xpand-multiselect");

        sttgs.pagesize = Number(sttgs.pagesize);
        if (!isNaN(sttgs.pagesize) && sttgs.pagesize > 0)
            sttgs.pageSize = sttgs.pagesize;
        delete sttgs.pagesize;

        if (sttgs.ismultiselect) {
            var counter = 0;
            var tempInterval = setInterval(function () {
                counter++;
                if (counter > 50) { clearInterval(tempInterval); }
                if (el.prev().length) {
                    el.prev().prepend('<span class="close-multidropdown" onmousedown="XPortal.Dropdown.closeMultiDropdown(this);" ontouchend="XPortal.Dropdown.closeMultiDropdown(this);"></span>');
                    clearInterval(tempInterval);
                }
            }, 10);
        }
        sttgs.isServerFiltering = sttgs.srvfilter == "1";/*!sttgs.ismultiselect &&*/
        ///setup kendo specific options
        sttgs.value = sttgs.ismultiselect && sttgs.value && sttgs.value.length ? sttgs.value.split(sttgs.valueSeparator) : sttgs.value;
        sttgs.kendoOptions = {
            filter: sttgs.filter ? sttgs.filter : "", dataTextField: "title", dataValueField: "value",
            suggest: false, index: -1, highlightFirst: false, delay: 500, clearButton: true, autoBind: true,
            ignoreCase: !sttgs.isServerFiltering,
            noDataTemplate: kendo.template(sttgs.nodata || ""),
            footerTemplate: sttgs.footer,
            value: sttgs.value
        };
        if (sttgs.template) sttgs.kendoOptions.template = kendo.template($(sttgs.template).html());

        ///setup server request options
        var bdata = $.extend({
            nodeId: sttgs.nodeid, fieldAlias: sttgs.alias, pageSize: sttgs.pageSize, pageIndex: 0,
            titleValue: sttgs.titleColumn, keyValue: sttgs.valueColumn,
            metaField: sttgs.fieldname, entityAlias: sttgs.entityalias,
            pageInfo: "", foterformat: sttgs.foterformat, modelName,
            computed: [{ name: "value", template: sttgs.valueColumn }, { name: "display", template: sttgs.titleColumn }, { name: "title", template: sttgs.lookupTemplate }]
        }, sttgs.search);
        bdata.sort = (sttgs.sortby && sttgs.sortby.length > 0) ? [{ field: "srt_" + sttgs.sortby, dir: "desc" }] : [{ field: "srt_" + sttgs.valueColumn, dir: "desc" }];

        bdata.startmval = !sttgs.ismultiselect ? (sttgs.value ? [sttgs.value] : []) : (sttgs.value || []);
        bdata.startLength = bdata.startmval.length;
        bdata.modelFields = modelFields;
        sttgs.bdata = bdata;
        sttgs.update = true;
        return sttgs;
    };


    function addMainQuery(rdata, options, mainQuery) {
        if (mainQuery) {
            rdata.mainQuery = mainQuery;
            options.data.filter.filters = [];
            options.data.page = options.data.pageIndex = 0;
        }
        return rdata;
    };
    function showHideLoader(kel, xsettings, show) {
        xsettings.bdata.loading = !(!show);
        var kboxList = (kel || {}).footer;
        if (!kboxList) return;
    }
    function onDataLoaded(el, sttgs, mval, xdata, nextAction, level) {
        const kobj = getKendoControl(el, sttgs);
        if (!kobj) console.log('there is no dropdown element anymore...', { sttgs, xdata, level });
        else {
            var selItem = self.GetSelectedValues(el, sttgs);

            reloadFooterPager(el, sttgs);
            nextAction(combineDataSource(xdata, selItem), level);
        };
    };
    function refreshPagingInfo(isettings, action) {
        if (action != null) isettings.action = action;
        isettings.footerVisible = isettings.total == null || (isettings.total > 0 && isettings.total > isettings.pageSize);
        if (isettings.total == null && isettings.total <= 0) return isettings.pageInfo = "";
        var startfrom = isettings.pageSize * isettings.pageIndex;
        startfrom = startfrom < 1 ? 1 : startfrom;
        var endTo = isettings.pageSize * (isettings.pageIndex + 1);
        var total = isettings.total;
        return isettings.pageInfo = XPortal.Template.ReplaceFormatString(isettings.foterformat, null, {
            startfrom: startfrom,
            endTo: Math.min(endTo, total),
            total: total,
            loading: isettings.loading
        }, {});

    };
    function reloadFooterPager(iel, sttgs, _dataSource, _xaction) {
        let el = getKendoControl(iel, sttgs);
        let footer = el.footer;
        let dataSource = _dataSource || el.dataSource;
        let xaction = _xaction || el.dataSource.options.xsettings.bdata.action;
        $(footer).off("click");
        var isettings = dataSource.options.xsettings.bdata;
        refreshPagingInfo(isettings, xaction);
        $(footer).on("click", ".combobox-btn", function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (self.isWorking) return;

            self.isWorking = true;
            var bel = $(this);
            var a = bel.attr("data-action");
            var px = Number(isettings.pageIndex);
            if (a == "next") isettings.pageIndex = isNaN(px) ? 1 : (px + 1 > isettings.total / isettings.pageSize) ? px : px + 1;
            if (a == "prev") isettings.pageIndex = isNaN(px) || px < 1 ? 0 : px - 1;
            if (a == "first") isettings.pageIndex = 0;

            if (isettings.pageIndex === px) {
                self.isWorking = false;
                return;
            }

            refreshPagingInfo(isettings, a);
            isettings.dataItems = self.GetSelectedValues(iel, sttgs);
            dataSource.page(isettings.pageIndex);
            self.isWorking = false;
        });
    };
    function getFormFields(el, sttgs) {
        const initialFields = sttgs.bdata.modelFields;
        const curModelFields = getModelFields(el, sttgs.bdata.modelName);
        if (curModelFields) return curModelFields;
        if (initialFields) return initialFields;
        const container = $(XPortal.Store.GetModelByName(sttgs.bdata.modelName).model.selector);
        let r = XPortal.EditForm.ProcessDetailFields(container);
        if (r && r.length > 0) {
            var runique = [];
            r.forEach(function (fi) {
                var efield = runique.find(function (efi) {
                    return efi.field == fi.field;
                });
                if (efield == null) runique.push(fi);
            });
            r = runique;
        };
        return r;
    };
    function getModelFields(el, modelName) {
        var rfields = ((XPortal.Store.GetModelByName(modelName) || {}).entity || {}).Fields;
        if (!rfields || rfields.length < 1) return [];

        rfields = rfields.map(function (fi) {
            var f = { data: "", field: "" };//Object.assign({}, fi);
            f.field = XPortal.Template.GetObjPropValueByName(fi, "Name");
            f.data = XPortal.Template.GetObjPropValueByName(fi, "StringValue");
            if (!(f.data)) f.data = XPortal.Template.GetObjPropValueByName(fi, "data");
            if (f.data && f.data.length > 8192) f.data = f.data.substring(0, 8192);//max data to send to the server
            return f;
        });
        return rfields;
    };
    function setDataItems(sttgs, modelName, mbox, cvalue) {
        var dVal = XPortal.Template.ReplaceFormatString(sttgs.lookupTemplate, null, XPortal.Store.GetModelByName(modelName).entity);
        var dItems = {
            display: dVal,
            title: dVal,
            value: sttgs.value
        };
        mbox.listView._dataItems.push(dItems);
        return dVal;
    }
    return self;
}());